import paymentDaysServiceGen from "./generated/paymentDaysServiceGen";

class paymentDaysService extends paymentDaysServiceGen {
}

export default paymentDaysService;